import Vue from 'vue'
import {
  Tooltip,
  Carousel,
  Slide,
  Collapse,
  Dropdown,
  Modal,
  Tab,
  Tabs,
  DatePicker,
  Alert,
  Pagination,
  Popover,
  TimePicker,
  Typeahead,
  ProgressBar,
  ProgressBarStack
} from 'uiv'

Vue.component('tooltip', Tooltip)
Vue.component('carousel', Carousel)
Vue.component('slide', Slide)
Vue.component('collapse', Collapse)
Vue.component('dropdown', Dropdown)
Vue.component('modal', Modal)
Vue.component('tab', Tab)
Vue.component('tabs', Tabs)
Vue.component('datePicker', DatePicker)
Vue.component('alert', Alert)
Vue.component('pagination', Pagination)
Vue.component('popover', Popover)
Vue.component('timePicker', TimePicker)
Vue.component('typeahead', Typeahead)
Vue.component('progressBar', ProgressBar)
Vue.component('progressBarStack', ProgressBarStack)



// WEBPACK FOOTER //
// ./client/plugins/uiv.js